import { render, staticRenderFns } from "./S10.vue?vue&type=template&id=232a263f&scoped=true&"
import script from "./S10.vue?vue&type=script&lang=js&"
export * from "./S10.vue?vue&type=script&lang=js&"
import style0 from "./S10.vue?vue&type=style&index=0&id=232a263f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232a263f",
  null
  
)

export default component.exports